module.exports = __webpack_public_path__ + "static/media/characteristics.15caa969.pdf";